import create from "zustand"
import { submissionListdata } from "../sdk"

type SubmissionsStore = {
  submissions: submissionListdata[] | null
  setSubmissions(submissions: submissionListdata[]): void
  reset(): void
}

type DefaultStateType = Pick<SubmissionsStore, "submissions">

const defaultState: DefaultStateType = {
  submissions: null
}

export const useSubmissions = create<SubmissionsStore>((set) => ({
  submissions: null,
  setSubmissions: (submissions: submissionListdata[]): void => set({ submissions }),
  reset: (): void => set((state) => ({ ...state, ...defaultState }))
}))